import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { EventArticle } from "../models/event-article";
import { EventPictureSets } from "../models/eventPictureSets";
import { EventArticlePictureRequest } from "../models/eventArticlePictureRequest";
import { eventAdditionalPictureRequest } from "../models/eventAdditionalPictureRequest";
import { additionalPicture } from "../models/additionalPicture";

@Injectable()
export class EventArticleService {
  constructor(private apiService: ApiService) {}

  /**
   * Get all Master Sporting Event
   */
  GetMasterSportingEvents(languageId: number) {
    return this.apiService
      .get("EventArticle/MasterSportingEvents?languageId=" + languageId)
      .map((res) => {
        if (res && res.values) {
          return res.values.map((value) => new EventArticle(value));
        } else {
          return [];
        }
      });
  }

  /**
   * Get pictures of a sporting Event by language Id
   */
  GetPictures(sportingEventId: number, languageId?: number) {
    return this.apiService
      .get(
        "EventArticle/" +
          sportingEventId +
          "/Pictures?languageId=" +
          (languageId != null ? languageId : "")
      )
      .map((res) => {
        if (res && res.values) {
          return res.values.map((value) => new EventArticle(value));
        } else {
          return [];
        }
      });
  }


  getPictureSets(
    sportingEventId: number,
    languageId: number,
    setId?: number
  ) {
    const url =
      "EventArticle/" +
      sportingEventId +
      "/" +
      languageId +
      "/" +
      setId +
      "/PictureSets";
    return this.apiService.get(url).map((res) => {
      if (res && res.value) {
        return new EventPictureSets(res.value);
      } else {
        return [];
      }
    });
  }

  /**
   * Update pictures with an API call
   * @param {ProgramArticle} eventArticle
   * @returns {Observable<EventArticle>}
   */
  uploadAdditionalPictures(
    eventArticle: EventPictureSets,
  ) {
    return this.apiService.post(
      "EventArticle/UploadAdditionalPictures",
      eventArticle
    );
  }

  /**
   * Post pictures of a sporting Event by language Id
   */
  PostPictures(data: any) {
    return this.apiService.post("EventArticle/Pictures", data).map((res) => {
      if (res) {
        return res.value;
      } else {
        return null;
      }
    });
  }

  
  getEventAdditionalsPicture(request: EventArticlePictureRequest) {
    const url = "EventArticle/AdditionalsPicture";
    return this.apiService.post(url, request).map((res) => {
      return res.values.map((value) => new additionalPicture(value));
    });
  }

  saveEventMaxAdditionalsPicture(request: eventAdditionalPictureRequest) {
    return this.apiService.post(
      "EventArticle/Save/AdditionalsPicture",
      request
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/event-article.service.ts